export enum LeadRegistrationStatus {
	UNKNOWN = 'UNKNOWN',
	EMAIL_SENT = 'EMAIL_SENT',
	REGISTERED = 'REGISTERED',
};

export const LeadRegistrationStatusName = {
	UNKNOWN: 'Не установлен',
	EMAIL_SENT: 'Отправлен e-mail',
	REGISTERED: 'Зарегистрирован',
};
